module.exports = __webpack_public_path__ + "static/media/A1-6-Glyndor-cod88.7511212e.png";